import type { FaireProductEntity } from "../../entity_types/product";

export const p_ea4336dzwz: FaireProductEntity = {
  token: "p_ea4336dzwz",
  type: "product",
  name: "Dirty Natural Deodorant Refill – Black Pepper & Eucalyptus",
  brandToken: "b_7t7wu79e8q",
  brandName: "Terra and Self",
  imageUrl:
    "https://cdn.faire.com/fastly/cd8f1689444d58b04462b507d8025d7c86f1716299b7d3e431d40abc208c250c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce8f47efda07b9dce2c5f7fe08feb1fd3323c3736a7dcfa5241b5b9cfc755a27.jpeg",
    "https://cdn.faire.com/fastly/cfa27567765f0ecc7eae80192bae9d6747612a6e4f8674cea00022c3566b0aed.png",
    "https://cdn.faire.com/fastly/8033e7e6cdcd5d8874b51c5ad6600bac31fa893500bed71c5d56547265abe312.png",
    "https://cdn.faire.com/fastly/1324d8978b7e43796e5d993df7e562f9538ce5ea5d0ed41dfd4224a68dda98e0.png",
  ],
  priceDollars: 6.24,
  description:
    "Dirty smells clean in a bold, no nonsense way. Fresh rosemary and eucalyptus hit first, sharp and energizing, followed by bright bergamot and a subtle kick of black pepper. Warm frankincense, cedarwood, and cypress ground it all with an earthy finish that feels confident and grown. It’s crisp, woodsy, and unapologetic. Powered by magnesium for all day odor protection that never quits.\n\nFeatures:\n-Plastic free and fully compostable refill\n-Gentle, aluminum free, and baking soda free formula\n-Magnesium powered odor protection that lasts all day\n-Smooth texture that won’t stain or irritate skin\n-Fresh, herbaceous, and woodsy scent profile\n-Designed for Terra & Self refillable deodorant tubes\n-Vegan, cruelty free, handcrafted in small batches\n",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:52.157Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
